import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(() => ({
  dateFieldContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  dateFieldText: {
    fontSize: 16,
    fontWeight: 400,
  },
  calendarIcon: {
    color: '#393939',
    margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? `5px 0 0 5px` : `5px 5px 0 0`,
  },
}));
